/**
 * WS10 belt container classname
 */
export var BELT_CONTAINER_BASE_CLASSNAME = 'ws10-belt-container';
